module.exports = __webpack_public_path__ + "ClientApp/images/content/angel_fund.png";